<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Debugger Module</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-bug me-1" style="color: #00A0C1;"></i>
                  Monitor upload interception metrics, database synchronization, and tracing diagnostics.
               </small>
            </div>
         </div>
      </div>

      <DebuggerModule />
   </div>
</template>

<script>
import DebuggerModule from '@/components/Admin Controls/DebuggerModule.vue';

export default {
   components: { DebuggerModule },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
</style>
